/* ==========================================================================
 * Brand Casa — Jenny Packham mega menu header + search overlay
 * --------------------------------------------------------------------------
 * Injects a full custom header with:
 *   - 5 top-level nav items (NEW IN | SHOP | BRIDAL | CAMPAIGNS | DISCOVER)
 *   - Full-width mega menus for SHOP and BRIDAL (multi-column + featured image)
 *   - Simple dropdowns for CAMPAIGNS and DISCOVER
 *   - Full-width search overlay with product results
 *   - Mobile drawer from the left
 *
 * Data below maps the design spec to Jenny Packham's REAL storefront URLs.
 * URLs verified against the live nav on Apr 24, 2026.
 *
 * Feature-flagged via settings.bc_megamenu_enabled — OFF by default.
 * When enabled, hides Prestige's native nav via CSS; disabling restores it.
 * ========================================================================== */
(function () {
  'use strict';

  var cfg = window.__bcMegaMenuConfig || {};
  if (cfg.enabled !== true) return;

  // ─── NAV DATA (real JP URLs) ────────────────────────────────────────────
  // The defaults below are the safety net. The actual nav structure on
  // live is pulled from the Shopify "BC Mega Menu" linklist (handle:
  // bc-mega-menu) that the merchant manages from Online Store > Navigation.
  // If that linklist exists and has links, the parser below replaces these
  // arrays at runtime. If the linklist is missing or empty, we fall back to
  // these defaults so the storefront never goes blank.
  var NAV_ITEMS = [
    { label: 'NEW IN',    href: '/collections/new-arrivals',       type: 'link' },
    { label: 'SHOP',      href: '/collections/all-collections',    type: 'megamenu', menu: 'SHOP' },
    { label: 'BRIDAL',    href: '/collections/bridal-collection',  type: 'megamenu', menu: 'BRIDAL' },
    { label: 'CAMPAIGNS', href: '#',                                type: 'dropdown', menu: 'CAMPAIGNS' },
    { label: 'DISCOVER',  href: '#',                                type: 'dropdown', menu: 'DISCOVER' }
  ];

  // SHOP menu is for SHOPPABLE collections (/collections/...).
  // Editorial lookbooks belong in the CAMPAIGNS menu (/pages/...).
  var SHOP_MENU = {
    columns: [
      {
        title: 'BY LENGTH',
        links: [
          { label: 'Shop All',   href: '/collections/all-collections' },
          { label: 'Gowns',      href: '/collections/gown-length-product' },
          { label: 'Midi',       href: '/collections/midi-length' },
          { label: 'Mini',       href: '/collections/mini-length' },
          { label: 'Separates',  href: '/collections/separates' }
        ]
      },
      {
        title: 'NEW ARRIVALS',
        links: [
          { label: 'Spring Summer 26',        href: '/collections/spring-summer-26' },
          { label: 'Resort Spring Summer 26', href: '/collections/resort-spring-summer-26' },
          { label: 'Spring Edit 26',          href: '/collections/spring-edit-26' },
          { label: 'Shop All New In',         href: '/collections/new-arrivals' }
        ]
      },
      {
        title: 'COLLECTIONS',
        links: [
          { label: 'Cocktail 26',          href: '/collections/spring-summer-cocktail-26' },
          { label: 'Spring Summer 26',     href: '/collections/spring-summer-26' },
          { label: 'Resort 26',            href: '/collections/resort-spring-summer-26' },
          { label: 'View All Collections', href: '/collections/all-collections' }
        ]
      }
    ],
    featured: {
      image: (cfg.shopFeatured && cfg.shopFeatured.image) || '//www.jennypackham.com/cdn/shop/files/JPEX388VALORIEMorganite_0.jpg?v=1772197808&width=600',
      title: (cfg.shopFeatured && cfg.shopFeatured.title) || 'Cocktail 25',
      subtitle: (cfg.shopFeatured && cfg.shopFeatured.subtitle) || 'Shop the Collection',
      href: (cfg.shopFeatured && cfg.shopFeatured.href) || '/collections/cocktail-25-collection'
    }
  };

  // BRIDAL: shoppable bridal links go under SHOP; lookbook/gallery pages
  // go under DISCOVER.
  var BRIDAL_MENU = {
    columns: [
      {
        title: 'SHOP',
        links: [
          { label: 'Shop All Bridal',  href: '/collections/bridal-collection' },
          { label: 'Bridal Party 25',  href: '/collections/bridal-party-25' },
          { label: 'Wedding Party',    href: '/collections/wedding-part' },
          { label: 'Wedding Guest',    href: '/collections/wedding-guest' }
        ]
      },
      {
        title: 'DISCOVER',
        links: [
          { label: 'Bride 2027',                href: '/pages/white-edit-27' },
          { label: 'Bride 2026 Gallery',        href: '/pages/white-edit-26-gallery' },
          { label: 'Bride 2025 Gallery',        href: '/pages/white-edit-25-gallery' },
          { label: 'Bridal Party 25 Gallery',   href: '/pages/bridal-party-2026-gallery' }
        ]
      }
    ],
    featured: {
      image: (cfg.bridalFeatured && cfg.bridalFeatured.image) || '//www.jennypackham.com/cdn/shop/files/ZDD102LHONESTYCrystalAqua_0.jpg?v=1762785421&width=600',
      title: (cfg.bridalFeatured && cfg.bridalFeatured.title) || 'Bride 2027',
      subtitle: (cfg.bridalFeatured && cfg.bridalFeatured.subtitle) || 'View the Lookbook',
      href: (cfg.bridalFeatured && cfg.bridalFeatured.href) || '/pages/white-edit-27'
    }
  };

  var CAMPAIGNS_MENU = [
    { label: 'Autumn Winter 26',       href: '/pages/aw-26-gallery-page' },
    { label: 'Pre Autumn Winter 26',   href: '/pages/pre-aw26-gallery' },
    { label: 'Summer Edit 26',         href: '/pages/summer-edits-26-gallery-page' },
    { label: 'Spring Cocktail 26',     href: '/pages/spring-cocktail-collection-26-gallery' },
    { label: 'Spring Summer 26',       href: '/pages/main-ss26-gallery' },
    { label: 'Cocktail 25',            href: '/pages/cocktail-collection-gallery' }
  ];

  var DISCOVER_MENU = [
    { label: 'News',    href: '/pages/news' },
    { label: 'About',   href: '/pages/about-jenny-packham' },
    { label: 'Contact', href: '/pages/contact' }
  ];

  // Popular products shown when the search overlay opens with an empty query.
  // Fallback-only — actual queries hit Shopify's Predictive Search API so
  // results stay in sync with live inventory.
  var POPULAR_PRODUCTS = [
    { name: 'Valorie', price: '£1,730', image: 'https://www.jennypackham.com/cdn/shop/files/JPEX388VALORIEMorganite_0.jpg?v=1772197808&width=400', href: '/products/valorie' },
    { name: 'Roma',    price: '£1,730', image: 'https://www.jennypackham.com/cdn/shop/files/JPEX387ROMALiquorice_0_c53f8edd-e28b-43da-8df1-1d85509e798f.jpg?v=1764322801&width=400', href: '/products/roma' },
    { name: 'Honesty', price: '£3,200', image: 'https://www.jennypackham.com/cdn/shop/files/ZDD102LHONESTYCrystalAqua_1_1.jpg?v=1762785421&width=400', href: '/products/honesty' },
    { name: 'Jules',   price: '£1,715', image: 'https://www.jennypackham.com/cdn/shop/files/JPEX391JULESMorganite_0.jpg?v=1772197855&width=400', href: '/products/jules' },
    { name: 'Odette',  price: '£1,730', image: 'https://www.jennypackham.com/cdn/shop/files/JPEX385ODETTELiquorice.Morganite_0.jpg?v=1772197773&width=400', href: '/products/odette' },
    { name: 'Lucy',    price: '£1,665', image: 'https://www.jennypackham.com/cdn/shop/files/JPEX390LUCYLiquorice_0.jpg?v=1764327350&width=400', href: '/products/lucy' }
  ];

  // ─── PARSE SHOPIFY NAVIGATION OVERRIDE ─────────────────────────────────
  // If the storefront emitted <script type="application/json" data-bc-menu-data>
  // with a populated bc-mega-menu linklist, parse it and rebuild the nav
  // arrays above so the menu reflects what the merchant set in Online Store
  // > Navigation. Each top level link's type is auto-derived:
  //   - no children          → bar link (no dropdown)
  //   - children with grand-children → multi-column megamenu (SHOP/BRIDAL style)
  //   - children with no grand-children → flat dropdown (CAMPAIGNS/DISCOVER style)
  (function applyShopifyNav() {
    var dataNode = document.querySelector('script[type="application/json"][data-bc-menu-data]');
    if (!dataNode) return;
    var data;
    try { data = JSON.parse(dataNode.textContent || '{}'); } catch (e) { return; }
    var navFromShopify = data && data.nav;
    if (!Array.isArray(navFromShopify) || navFromShopify.length === 0) return;

    var newNavItems = [];
    navFromShopify.forEach(function (top) {
      var label = (top.label || '').toUpperCase();
      var children = Array.isArray(top.children) ? top.children : [];
      if (children.length === 0) {
        newNavItems.push({ label: label, href: top.href || '#', type: 'link' });
        return;
      }
      var anyGrand = children.some(function (c) { return Array.isArray(c.children) && c.children.length > 0; });
      if (anyGrand) {
        // Multi-column megamenu. Children with grandchildren become column
        // headers; children without grandchildren become a single anonymous
        // "More" column so flat links inside a megamenu still render.
        var columns = [];
        var flatLinksInMega = [];
        children.forEach(function (c) {
          if (Array.isArray(c.children) && c.children.length > 0) {
            columns.push({
              title: (c.label || '').toUpperCase(),
              links: c.children.map(function (leaf) {
                return { label: leaf.label || '', href: leaf.href || '#' };
              })
            });
          } else {
            flatLinksInMega.push({ label: c.label || '', href: c.href || '#' });
          }
        });
        if (flatLinksInMega.length > 0) {
          columns.unshift({ title: 'SHOP', links: flatLinksInMega });
        }
        // Pick the right featured banner for this megamenu. Order of
        // preference: a generic banner whose label matches this menu (set
        // via theme settings Banner 1-4), then the legacy SHOP / BRIDAL
        // featured config, then SHOP as a final fallback.
        var matchedBanner = null;
        if (Array.isArray(cfg.banners)) {
          matchedBanner = cfg.banners.find(function (b) {
            return (b.label || '').trim().toUpperCase() === label;
          });
        }
        var featured;
        if (matchedBanner) {
          featured = {
            image: matchedBanner.image || SHOP_MENU.featured.image,
            title: matchedBanner.title || '',
            subtitle: matchedBanner.subtitle || '',
            href: matchedBanner.href || '#'
          };
        } else if (label === 'SHOP') {
          featured = SHOP_MENU.featured;
        } else if (label === 'BRIDAL') {
          featured = BRIDAL_MENU.featured;
        } else {
          featured = SHOP_MENU.featured;
        }
        newNavItems.push({
          label: label,
          href: top.href || '#',
          type: 'megamenu',
          menu: label,
          // Carry the menu's data on the item itself so the renderer no
          // longer depends on hardcoded SHOP_MENU / BRIDAL_MENU globals.
          menuData: { columns: columns, featured: featured }
        });
      } else {
        // Flat dropdown — all children are leaves.
        newNavItems.push({
          label: label,
          href: top.href || '#',
          type: 'dropdown',
          menu: label,
          menuData: children.map(function (c) {
            return { label: c.label || '', href: c.href || '#' };
          })
        });
      }
    });
    NAV_ITEMS = newNavItems;
  })();

  // ─── SVG ICON LIBRARY ────────────────────────────────────────────────────
  var ICONS = {
    search:
      '<svg aria-hidden="true" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>',
    account:
      '<svg aria-hidden="true" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
    cart:
      '<svg aria-hidden="true" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>',
    close:
      '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
    menu:
      '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>',
    chevron:
      '<svg aria-hidden="true" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>'
  };

  function el(tag, cls, attrs) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (attrs) for (var k in attrs) n.setAttribute(k, attrs[k]);
    return n;
  }
  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }
  function money(v) {
    if (v == null || v === '') return '';
    var n = typeof v === 'string' ? parseFloat(v) : Number(v);
    if (!isFinite(n)) return '';
    var symbol = '£';
    try { if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'USD') symbol = '$'; } catch (e) {}
    var s = n.toFixed(2).replace(/\.00$/, '');
    s = s.replace(/\B(?=(\d{3})+(?!\d))/, ',');
    return symbol + s;
  }

  // ─── LOGO LOOKUP ────────────────────────────────────────────────────────
  function getLogoSrc() {
    // Try to pick up Prestige's existing logo (white variant preferred for dark header)
    var existing = document.querySelector('.header__logo img, x-header img');
    if (existing && existing.src) return existing.src;
    return '//www.jennypackham.com/cdn/shop/files/Logo_White.webp?v=1681818283&width=600';
  }

  // ─── MARKUP BUILDERS ────────────────────────────────────────────────────
  function buildColumns(menu) {
    var html = '';
    menu.columns.forEach(function (col) {
      html += '<div class="bcmm__col">';
      html += '<h3 class="bcmm__coltitle">' + esc(col.title) + '</h3>';
      html += '<ul class="bcmm__collist">';
      col.links.forEach(function (l) {
        html += '<li><a href="' + esc(l.href) + '">' + esc(l.label) + '</a></li>';
      });
      html += '</ul>';
      html += '</div>';
    });
    // Featured image column
    if (menu.featured) {
      html +=
        '<a class="bcmm__featured" href="' + esc(menu.featured.href) + '">' +
          '<div class="bcmm__featured-media">' +
            '<img src="' + esc(menu.featured.image) + '" alt="" loading="lazy">' +
          '</div>' +
          '<div class="bcmm__featured-info">' +
            '<h3 class="bcmm__featured-title">' + esc(menu.featured.title) + '</h3>' +
            '<span class="bcmm__featured-sub">' + esc(menu.featured.subtitle) + ' ' + ICONS.chevron + '</span>' +
          '</div>' +
        '</a>';
    }
    return html;
  }

  function buildSimpleDropdown(items) {
    var html = '<ul class="bcmm__dropdown-list">';
    items.forEach(function (l) {
      html += '<li><a href="' + esc(l.href) + '">' + esc(l.label) + '</a></li>';
    });
    html += '</ul>';
    return html;
  }

  function buildHeader() {
    var header = el('header', 'bcmm');
    header.setAttribute('data-bcmm', '');

    // Mobile hamburger
    var hamburger = el('button', 'bcmm__burger', { type: 'button', 'aria-label': 'Open menu' });
    hamburger.innerHTML = ICONS.menu;

    // Logo
    var logoLink = el('a', 'bcmm__logo', { href: '/', 'aria-label': 'Jenny Packham — home' });
    var logoImg = el('img', null, { src: getLogoSrc(), alt: 'Jenny Packham', loading: 'eager' });
    logoLink.appendChild(logoImg);

    // Primary nav
    var nav = el('nav', 'bcmm__nav', { 'aria-label': 'Primary' });
    var navList = el('ul', 'bcmm__navlist');
    NAV_ITEMS.forEach(function (item) {
      var li = el('li', 'bcmm__navitem bcmm__navitem--' + item.type, { 'data-menu': item.menu || '' });
      var a = el('a', 'bcmm__navlink', { href: item.href });
      a.textContent = item.label;
      li.appendChild(a);
      navList.appendChild(li);
    });
    nav.appendChild(navList);

    // Right-side icons
    var icons = el('div', 'bcmm__icons');
    var searchBtn = el('button', 'bcmm__icon bcmm__icon-search', { type: 'button', 'aria-label': 'Search' });
    searchBtn.innerHTML = ICONS.search;
    var accountA = el('a', 'bcmm__icon', { href: '/account', 'aria-label': 'Account' });
    accountA.innerHTML = ICONS.account;
    var cartA = el('a', 'bcmm__icon bcmm__icon-cart', { href: '/cart', 'aria-label': 'Cart', 'aria-controls': 'cart-drawer' });
    cartA.innerHTML = ICONS.cart + '<span class="bcmm__cart-count" data-bcmm-cart-count>0</span>';
    icons.append(searchBtn, accountA, cartA);

    // Bar inner layout — desktop grid is `auto 1fr auto`:
    //   logo (left) | nav (fills middle) | icons (right)
    // Mobile grid is `auto 1fr auto` with burger replacing nav.
    var bar = el('div', 'bcmm__bar');
    bar.append(hamburger, logoLink, nav, icons);
    header.appendChild(bar);

    // Iterate over the nav items and build a panel for every megamenu /
    // dropdown item. This used to be hardcoded to SHOP / BRIDAL / CAMPAIGNS /
    // DISCOVER, but the menu structure now comes from Shopify Navigation
    // (e.g. SHOP READY-TO-WEAR, SHOP EDITS, etc.), so panels are created
    // dynamically based on whichever items the merchant has.
    NAV_ITEMS.forEach(function (item) {
      if (!item.menu) return;
      if (item.type === 'megamenu') {
        var p = el('div', 'bcmm__panel bcmm__panel--mega', { 'data-panel': item.menu, hidden: 'hidden' });
        var data = item.menuData || (item.menu === 'SHOP' ? SHOP_MENU : item.menu === 'BRIDAL' ? BRIDAL_MENU : null);
        if (data) {
          p.innerHTML = '<div class="bcmm__panel-inner">' + buildColumns(data) + '</div>';
          header.appendChild(p); // mega panels span full width, attach to header
        }
      } else if (item.type === 'dropdown') {
        var data = item.menuData || (item.menu === 'CAMPAIGNS' ? CAMPAIGNS_MENU : item.menu === 'DISCOVER' ? DISCOVER_MENU : null);
        if (data) {
          var p = el('div', 'bcmm__panel bcmm__panel--dropdown', { 'data-panel': item.menu, hidden: 'hidden' });
          p.innerHTML = buildSimpleDropdown(data);
          // Dropdown panels must be inside the matching nav item li so they
          // position relative to it (CSS selector requirement).
          // CSS attribute selectors with quoted values handle spaces and
          // hyphens natively, so no escaping is needed beyond a basic quote
          // sanity check — the menu key comes from Shopify menu labels which
          // never contain a literal double quote.
          var li = navList.querySelector('.bcmm__navitem[data-menu="' + item.menu.replace(/"/g, '') + '"]');
          (li || header).appendChild(p);
        }
      }
    });

    // Search overlay
    var search = el('div', 'bcmm__search', { hidden: 'hidden', role: 'dialog', 'aria-label': 'Search' });
    search.innerHTML =
      '<div class="bcmm__search-backdrop" data-bcmm-search-close></div>' +
      '<div class="bcmm__search-panel">' +
        '<form class="bcmm__search-form" role="search" action="/search" method="get">' +
          '<input type="hidden" name="type" value="product">' +
          '<span class="bcmm__search-icon">' + ICONS.search + '</span>' +
          '<input class="bcmm__search-input" type="search" name="q" placeholder="Search products" aria-label="Search products" autocomplete="off">' +
          '<button type="button" class="bcmm__search-close" data-bcmm-search-close aria-label="Close search">' + ICONS.close + '</button>' +
        '</form>' +
        '<div class="bcmm__search-results" role="listbox"></div>' +
      '</div>';
    header.appendChild(search);

    // Mobile drawer
    var drawer = el('aside', 'bcmm__drawer', { hidden: 'hidden', 'aria-label': 'Menu' });
    drawer.innerHTML =
      '<div class="bcmm__drawer-backdrop" data-bcmm-drawer-close></div>' +
      '<div class="bcmm__drawer-panel">' +
        '<div class="bcmm__drawer-head">' +
          '<a href="/" class="bcmm__drawer-logo" aria-label="Jenny Packham — home"><img src="' + esc(getLogoSrc()).replace('Logo_White', 'Logo') + '" alt="Jenny Packham"></a>' +
          '<button type="button" class="bcmm__drawer-close" data-bcmm-drawer-close aria-label="Close menu">' + ICONS.close + '</button>' +
        '</div>' +
        '<form class="bcmm__drawer-search" role="search" action="/search" method="get">' +
          '<input type="hidden" name="type" value="product">' +
          '<span class="bcmm__drawer-search-icon">' + ICONS.search + '</span>' +
          '<input class="bcmm__drawer-search-input" type="search" name="q" placeholder="Search products" aria-label="Search products">' +
        '</form>' +
        '<nav class="bcmm__drawer-nav" aria-label="Mobile primary"></nav>' +
      '</div>';
    header.appendChild(drawer);

    // Populate drawer nav
    var drawerNav = drawer.querySelector('.bcmm__drawer-nav');
    function drawerSection(title, items) {
      var sec = document.createElement('section');
      sec.className = 'bcmm__drawer-section';
      var h = document.createElement('h3'); h.className = 'bcmm__drawer-title'; h.textContent = title;
      var list = document.createElement('ul'); list.className = 'bcmm__drawer-list';
      items.forEach(function (l) {
        var li = document.createElement('li');
        var a = document.createElement('a'); a.href = l.href; a.textContent = l.label;
        li.appendChild(a); list.appendChild(li);
      });
      sec.append(h, list);
      return sec;
    }
    // Drawer nav is built dynamically from NAV_ITEMS too so it tracks
    // whatever the merchant has in Shopify Navigation. Links with no
    // children are surfaced as a single-link section so they still appear
    // in the mobile drawer.
    NAV_ITEMS.forEach(function (item) {
      if (item.type === 'link') {
        drawerNav.appendChild(drawerSection(item.label, [{ label: 'View ' + item.label, href: item.href }]));
      } else if (item.type === 'megamenu') {
        var data = item.menuData || (item.menu === 'SHOP' ? SHOP_MENU : item.menu === 'BRIDAL' ? BRIDAL_MENU : null);
        if (data && data.columns) {
          data.columns.forEach(function (c) {
            drawerNav.appendChild(drawerSection(item.label + ' — ' + c.title, c.links));
          });
        }
      } else if (item.type === 'dropdown') {
        var data = item.menuData || (item.menu === 'CAMPAIGNS' ? CAMPAIGNS_MENU : item.menu === 'DISCOVER' ? DISCOVER_MENU : null);
        if (data && data.length) {
          drawerNav.appendChild(drawerSection(item.label, data));
        }
      }
    });

    return { header: header, hamburger: hamburger, searchBtn: searchBtn, searchEl: search, drawer: drawer };
  }

  // ─── SEARCH FETCHER ─────────────────────────────────────────────────────
  function fetchSuggest(q) {
    return fetch(
      '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=6' +
      '&resources[options][unavailable_products]=last',
      { credentials: 'same-origin' }
    ).then(function (r) { return r.ok ? r.json() : null; })
     .then(function (j) {
        if (!j || !j.resources || !j.resources.results) return [];
        return j.resources.results.products || [];
     })
     .catch(function () { return []; });
  }

  // Normalise Shopify Predictive Search product → { name, price, image, href }
  function normaliseProduct(p) {
    var href = p.url || (p.handle ? '/products/' + p.handle : '#');
    // `p.image` is a plain URL string; `p.featured_image` is an object
    // with `.url` (sometimes `.src` on older responses). Prefer the string.
    var img = p.image || '';
    if (!img && p.featured_image) {
      img = typeof p.featured_image === 'string'
        ? p.featured_image
        : (p.featured_image.url || p.featured_image.src || '');
    }
    var priceRaw = p.price != null ? p.price : p.price_min;
    return {
      name: p.title || '',
      price: priceRaw != null ? money(priceRaw) : '',
      image: img || '',
      href: href
    };
  }

  function cardHtml(p) {
    return (
      '<a class="bcmm__search-card" href="' + esc(p.href) + '">' +
        '<div class="bcmm__search-media">' +
          (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') +
        '</div>' +
        '<div class="bcmm__search-name">' + esc(p.name) + '</div>' +
        (p.price ? '<div class="bcmm__search-price">' + esc(p.price) + '</div>' : '') +
      '</a>'
    );
  }

  function renderPopular(container) {
    var html = '<div class="bcmm__search-label">Popular Products</div>';
    html += '<div class="bcmm__search-grid">';
    POPULAR_PRODUCTS.forEach(function (p) { html += cardHtml(p); });
    html += '</div>';
    container.innerHTML = html;
  }

  function renderSearchResults(container, products, query) {
    if (!query) {
      renderPopular(container);
      return;
    }
    if (!products.length) {
      container.innerHTML =
        '<div class="bcmm__search-label">0 Results</div>' +
        '<div class="bcmm__search-empty">No products found for “' + esc(query) + '”.</div>';
      return;
    }
    var normalised = products.map(normaliseProduct);
    var count = normalised.length;
    var html = '<div class="bcmm__search-label">' + count + ' Result' + (count === 1 ? '' : 's') + '</div>';
    html += '<div class="bcmm__search-grid">';
    normalised.forEach(function (p) { html += cardHtml(p); });
    html += '</div>';
    html +=
      '<a class="bcmm__search-view-all" href="/search?q=' + encodeURIComponent(query) + '&type=product">' +
        'View All Results' +
        '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>' +
      '</a>';
    container.innerHTML = html;
  }

  // ─── CART COUNT SYNC ────────────────────────────────────────────────────
  function refreshCartCount(header) {
    var badge = header.querySelector('[data-bcmm-cart-count]');
    if (!badge) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) return;
        var count = c.item_count || 0;
        badge.textContent = count;
        badge.style.display = count > 0 ? '' : 'none';
      })
      .catch(function () {});
  }

  // ─── WIRE INTERACTIONS ──────────────────────────────────────────────────
  function wire(ui) {
    var header = ui.header;
    var activePanel = null;
    var closeTimer = null;

    function closeAllPanels(immediate) {
      function doClose() {
        header.querySelectorAll('.bcmm__panel').forEach(function (p) { p.hidden = true; p.classList.remove('is-open'); });
        header.querySelectorAll('.bcmm__navitem').forEach(function (li) { li.classList.remove('is-active'); });
        activePanel = null;
      }
      if (immediate) { clearTimeout(closeTimer); doClose(); }
      else { clearTimeout(closeTimer); closeTimer = setTimeout(doClose, 150); }
    }
    function openPanel(name, triggerLi) {
      clearTimeout(closeTimer);
      header.querySelectorAll('.bcmm__panel').forEach(function (p) {
        if (p.dataset.panel === name) { p.hidden = false; requestAnimationFrame(function(){ p.classList.add('is-open'); }); }
        else { p.hidden = true; p.classList.remove('is-open'); }
      });
      header.querySelectorAll('.bcmm__navitem').forEach(function (li) { li.classList.remove('is-active'); });
      if (triggerLi) triggerLi.classList.add('is-active');
      activePanel = name;
    }

    header.querySelectorAll('.bcmm__navitem[data-menu]').forEach(function (li) {
      var menu = li.getAttribute('data-menu');
      if (!menu) return;
      li.addEventListener('mouseenter', function () { openPanel(menu, li); });
      li.addEventListener('mouseleave', function () { closeAllPanels(false); });
    });
    header.querySelectorAll('.bcmm__panel').forEach(function (p) {
      p.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      p.addEventListener('mouseleave', function () { closeAllPanels(false); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllPanels(true); });

    // Search overlay
    var searchEl = ui.searchEl;
    var searchInput = searchEl.querySelector('.bcmm__search-input');
    var searchResults = searchEl.querySelector('.bcmm__search-results');
    var searchDebounce = null;
    function openSearch() {
      searchEl.hidden = false;
      renderPopular(searchResults);
      requestAnimationFrame(function(){ searchEl.classList.add('is-open'); });
      document.body.classList.add('bcmm-scroll-lock');
      setTimeout(function () { searchInput.focus(); }, 20);
    }
    function closeSearch() {
      searchEl.classList.remove('is-open');
      setTimeout(function(){ searchEl.hidden = true; }, 250);
      searchInput.value = '';
      searchResults.innerHTML = '';
      document.body.classList.remove('bcmm-scroll-lock');
    }
    ui.searchBtn.addEventListener('click', openSearch);
    searchEl.querySelectorAll('[data-bcmm-search-close]').forEach(function (b) { b.addEventListener('click', closeSearch); });
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(searchDebounce);
      if (!q) { renderPopular(searchResults); return; }
      if (q.length < 2) return; // wait for at least 2 chars before hitting API
      searchDebounce = setTimeout(function () {
        fetchSuggest(q).then(function (p) { renderSearchResults(searchResults, p, q); });
      }, 180);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !searchEl.hidden) closeSearch();
    });

    // Mobile drawer
    var drawer = ui.drawer;
    function openDrawer() { drawer.hidden = false; requestAnimationFrame(function(){ drawer.classList.add('is-open'); }); document.body.classList.add('bcmm-scroll-lock'); }
    function closeDrawer() { drawer.classList.remove('is-open'); setTimeout(function(){ drawer.hidden = true; }, 300); document.body.classList.remove('bcmm-scroll-lock'); }
    ui.hamburger.addEventListener('click', openDrawer);
    drawer.querySelectorAll('[data-bcmm-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });

    // Cart count
    refreshCartCount(header);
    // Refresh on focus (user may have added to cart elsewhere)
    window.addEventListener('pageshow', function () { refreshCartCount(header); });
    // Listen to Prestige cart:change events if emitted
    document.addEventListener('cart:update', function () { refreshCartCount(header); });
  }

  // ─── INIT ────────────────────────────────────────────────────────────────
  function init() {
    if (document.querySelector('.bcmm')) return;
    document.body.classList.add('bcmm-active');
    var ui = buildHeader();
    // Insert the mega menu directly after the sitewide announcement bar (if
    // present), otherwise at the top of body. Without this, the announcement
    // bar ends up rendering UNDER the megamenu because the megamenu prepends
    // itself as body.firstChild.
    var announcement = document.querySelector('.bc-announcement');
    if (announcement && announcement.parentNode === document.body) {
      announcement.parentNode.insertBefore(ui.header, announcement.nextSibling);
    } else {
      document.body.insertBefore(ui.header, document.body.firstChild);
    }
    wire(ui);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
